import { Controller, type Control, type UseFormWatch } from 'react-hook-form';
import { FormInput } from '@/components/FormInput';
import { FormSelect } from '@/components/FormSelect';
import type { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { MARITAL_STATUS_OPTIONS } from '../../dataUpdate.definitions';

const WITH_SPOUSE = ['Casado(a)', 'União Estável'];

interface MaritalStatusFieldsProps {
    control: Control<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    disabled: boolean;
}

export function MaritalStatusFields({ control, watch, disabled }: MaritalStatusFieldsProps) {
    const status = watch('maritalStatus');
    const needsSpouse = WITH_SPOUSE.includes(status ?? '');

    return (
        <div className="grid gap-4 sm:grid-cols-2">
            <Controller
                name="maritalStatus"
                control={control}
                render={({ field, fieldState }) => (
                    <FormSelect
                        label="Estado civil"
                        name={field.name}
                        value={field.value ?? ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        options={MARITAL_STATUS_OPTIONS}
                        placeholder="Selecione"
                        disabled={disabled}
                        error={fieldState.error?.message}
                        required
                    />
                )}
            />
            {needsSpouse && (
                <Controller
                    name="spouseName"
                    control={control}
                    render={({ field, fieldState }) => (
                        <FormInput
                            label="Nome do cônjuge"
                            name={field.name}
                            value={field.value ?? ''}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={disabled}
                            error={fieldState.error?.message}
                            required
                        />
                    )}
                />
            )}
        </div>
    );
}
